import { ogImageMeta } from "@/lib/seo/og-image";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { MediaAnalysisOverviewBg } from "@/components/site/MediaAnalysisOverviewBg";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

import { pageSchemas } from "@/lib/seo/page-schema";
const META_DESCRIPTION =
  "Медийните анализи на Perceptica превръщат медийното отразяване в стратегическо медийно разузнаване - анализ на репутацията, кризисен мониторинг, конкурентно разузнаване и анализ на работодателския бранд.";

export const Route = createFileRoute("/bg/media-analysis")({
  head: () => ({
    meta: [
      { title: "Медийни анализи и медийно разузнаване | Perceptica" },
      { name: "description", content: META_DESCRIPTION },
      { property: "og:title", content: "Медийни анализи и медийно разузнаване | Perceptica" },
      { property: "og:description", content: META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медийни анализи и медийно разузнаване | Perceptica" },
      { name: "twitter:description", content: META_DESCRIPTION },
      { property: "og:url", content: "https://perceptica.com/bg/media-analysis" },
      ...ogImageMeta("bg", "/media-analysis"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-analysis", service: { name: "Медиен анализ", description: "Медиен анализ и медийно разузнаване от Perceptica за Югоизточна Европа.", serviceType: "Медиен анализ" }, collection: { name: "Media analysis services", description: "All Perceptica media analysis services" } }),
  }),
  component: BgMediaAnalysisLayout,
});

function BgMediaAnalysisLayout() {
  const { pathname } = useLocation();
  const isOverview = pathname === "/bg/media-analysis";

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader transparentOverHero />
      <main id="main">
        {isOverview ? <MediaAnalysisOverviewBg /> : <Outlet />}
      </main>
      <SiteFooter />
    </div>
  );
}
